import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-employee',
  templateUrl: './add-employee.component.html',
  styleUrls: ['./add-employee.component.scss']
})
export class AddEmployeeComponent implements OnInit {

  currentLang = localStorage.getItem('lang') || 'en'; // or however you store it

  employee: any;
  cites: any;
  cities: any;
formData: any = {
  name: '',
  email: '',
  city_id: '',
  phone: '',
  identity_number: '',
  job_title_id: '',
  nationality_id: '',
  image: null,
};
//  jobTitles: any[] = [
//     { id: 1, name: 'Software Engineer' },
//     { id: 2, name: 'Project Manager' },
//     { id: 3, name: 'UI/UX Designer' }
//   ];

   jobTitles: any[] = [];
  imageInput: any;
  imgInV: any;
  countries: any;

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService,private translate: TranslateService
  ) {}

    ngOnInit(): void {
       this.currentLang = localStorage.getItem('currentLang') || 'ar';
      this.fetchJobTitles();
      // this.getCities();
      this.getCountries();

        this.apisService.employee().subscribe({ 
      next:(response:any)=> { 
        this.employee = response.data || [] ;
        console.log('response is' , this.employee)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })

    }

     fetchJobTitles(): void {
    this.apisService.getJobTitles().subscribe({
      next: (res) => (this.jobTitles = res),
      // error: () => this.toastr.error('Failed to load job titles')
    });
  }

    onNationalityChange(): void {
    if (this.formData.nationality_id) {
      this.getCities(this.formData.nationality_id);
              console.log('this.formData.nationality_id :', this.formData.nationality_id);

      // إعادة تعيين المدينة عند تغيير الجنسية
      this.formData.city_id = '';
    } else {
      this.cities = [];
      this.formData.city_id = '';
    }
  }
     getCities(nationalityId: string): void {
    this.apisService.getCitiesById(nationalityId).subscribe({ 
      next: (response: any) => { 
      this.cities = response.data ? [response.data] : [];
            this.cities = response.data || [];

        console.log('Cities loaded:', this.cities);
      }, 
      error: (err) => { 
        console.log('Error fetching cities:', err);
        this.cities = [];
      }
    });
  }
    getCountries(){
       this.apisService.getCountriesM().subscribe({ 
      next:(response:any)=> { 
        this.countries = response.data || [] ;
        console.log('response from countries ' , this.countries)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
    }
//   onFileSelected(event: any): void {
//   if (event.target.files.length > 0) {
//     this.formData.image = event.target.files[0];
//   }
// }

onFileSelected(event: any): void {
  const file = event.target.files[0];
  this.imgInV= file
  if (file) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.formData.image = e.target.result;
      
    };
    reader.readAsDataURL(file);
  }
}

removeImage(): void {
  this.formData.image = null;
  // إعادة تعيين حقل الرفع
  this.imageInput.nativeElement.value = '';
}
    cancel(): void {
      this.router.navigate(['/employees']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
  onSubmit(): void {
   const form = new FormData();
  form.append('name', this.formData.name);
  form.append('email', this.formData.email);
  form.append('city_id', this.formData.city_id);
  form.append('phone', this.formData.phone);
  form.append('nationality', this.formData.nationality_id);
  form.append('job_title_id', this.formData.job_title_id);
  form.append('identity_number', this.formData.identity_number);

  if (this.formData.image) {
    form.append('image', this.imgInV);
  }

  this.apisService.addEmployee(form).subscribe({
    next: (response: any) => {
      this.translate.get([
        'MENU.DASHBOARD.EMPLOYEE_ADD_SUCCESS_TITLE',
        'MENU.DASHBOARD.EMPLOYEE_ADD_SUCCESS_MESSAGE'
      ]).subscribe(translations => {
        this.toastr.success(
          translations['MENU.DASHBOARD.EMPLOYEE_ADD_SUCCESS_MESSAGE'],
          translations['MENU.DASHBOARD.EMPLOYEE_ADD_SUCCESS_TITLE'],
          {
            positionClass: 'toast-top-center',
            timeOut: 3000,
            progressBar: true,
            closeButton: true
          }
        );
      });

      this.router.navigate(['/employees']);
    },

    error: (error: any) => {
      console.error('Error adding employee:', error);



  // 1️⃣ Show backend message (Preview tab)
  if (error?.error?.message) {
    this.toastr.error(
      error.error.message,
      this.translate.instant('MENU.DASHBOARD.ERROR_TITLE'),
      {
        positionClass: 'toast-top-center',
        timeOut: 4000,
        progressBar: true,
        closeButton: true
      }
    );
    return;
  }

  // 2️⃣ Show first validation error from backend
  if (error?.error?.errors) {
    const firstKey = Object.keys(error.error.errors)[0];
    const firstMessage = error.error.errors[firstKey]?.[0];

    if (firstMessage) {
      this.toastr.error(
        firstMessage,
        this.translate.instant('MENU.DASHBOARD.ERROR_TITLE'),
        {
          positionClass: 'toast-top-center',
          timeOut: 4000,
          progressBar: true,
          closeButton: true
        }
      );
      return;
    }
  }

  // 3️⃣ Fallback translated generic error
  this.toastr.error(
    this.translate.instant('MENU.DASHBOARD.GENERIC_ERROR'),
    this.translate.instant('MENU.DASHBOARD.ERROR_TITLE')
  );


      this.translate.get([
        'MENU.DASHBOARD.ERROR_TITLE',
        'MENU.DASHBOARD.GENERIC_ERROR',
        'MENU.DASHBOARD.FIELD_EMAIL_ERROR',
        'MENU.DASHBOARD.FIELD_JOB_TITLE_ERROR',
        'MENU.DASHBOARD.FIELD_NAME_ERROR',
        'MENU.DASHBOARD.FIELD_PHONE_ERROR'
      ]).subscribe(translations => {
        if (error.error && error.error.errors) {
          const errors = error.error.errors;

          if (errors.email)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_EMAIL_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.job_title_id)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_JOB_TITLE_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.name)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_NAME_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
          if (errors.phone)
            this.toastr.error(
              translations['MENU.DASHBOARD.FIELD_PHONE_ERROR'],
              translations['MENU.DASHBOARD.ERROR_TITLE']
            );
        } else {
          this.toastr.error(
            translations['MENU.DASHBOARD.GENERIC_ERROR'],
            translations['MENU.DASHBOARD.ERROR_TITLE']
          );
        }
      });
    }
  });
}



}